/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import { Registration } from './components/Registration'
import { ForgotPassword } from './components/ForgotPassword'
import { ResetPassword } from './components/ResetPassword'
import { Login } from './components/Login'
import Header from './components/Header';
import Footer from './components/Footer';
import Benefits from './components/Benefits';
import Us from './components/Us';
import './components/Login.css';
import { formatRut } from '../../Functions';

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <>
      <div className="main-container">
        <Header />
        <section className="main-section">
          <div className="login-container">
            <div className="container-form-intranet">
              <div className="logo-wrap">
                <i className=""></i>
              </div>

              <div className="cuerpo-login">

                <div className="logo-login">
                  <img src="https://noticias.amsm.cl/img/login-icon.svg" alt="" />
                </div>
                <br />
                <h5 className="title-acceso">
                  Mi AMSM
                </h5>
                <div className='card px-5'>
                    <Outlet />
                </div>
              </div>
            </div>
          </div>

          <Us />
          <Benefits />

        </section>
        <Footer formatRut={formatRut} />
      </div >
    </>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password' element={<ResetPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { AuthPage }
